import React, { useEffect } from "react";
import { Form, Checkbox, Select } from "antd";

function DropCheck({
    form,
    name,
    label,
    width,
    labelCol,
    required,
    errorMessage,
    validateFunction,
    defaultValue,
    options,
    onChange,
    disabled,
    className,
    data,
    bg,
    controlHeight,
    placeholder
}) {

    useEffect(() => {
        if (defaultValue) {
            form.setFieldsValue({ [name]: defaultValue });
        }
    }, []);

    return (
        <Form.Item
            className={className}
            name={name}
            label={label}
            labelCol={{ span: labelCol ? labelCol : 8 }}
            style={{ width: width, fontWeight: 600 }}
            rules={[
                {
                    required: required,
                    message: errorMessage,
                },
                () => ({
                    validator(rule, value) {
                        return validateFunction
                            ? validateFunction(rule, value)
                            : Promise.resolve();
                    },
                }),
            ]}
        >
            <Checkbox.Group
                disabled={disabled}
                defaultValue={defaultValue}
                style={{ fontWeight: 600, width: "100%" }}
                onChange={onChange}
            >
                {options.map((opt, index) => {
                    return (
                        <div>
                            <Checkbox key={index} value={opt.value} style={{ fontWeight: 600 }}>
                                {''}
                            </Checkbox>
                            <Select
                                style={{ background: bg, height: controlHeight || 40 }}
                                loading={false}
                                showSearch={true}
                                //onChange={}
                                //  defaultValue={defaultValue}
                                placeholder={placeholder}
                                defaultActiveFirstOption={true}
                                disabled={disabled}
                                mode={false}
                                options={[
                                    { label: 'A 1', value: 'a1' },
                                    { label: 'A 2', value: 'a2' },
                                    { label: 'A 3', value: 'a3' },
                                    { label: 'A 4', value: 'a4' },
                                    { label: 'A 5', value: 'a5' },
                                    { label: 'A 6', value: 'a6' },
                                ]}
                            />
                        </div>
                    );
                })}
            </Checkbox.Group>
        </Form.Item>
    );
}

export default DropCheck;
